import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import axios from "axios";
import global_ from '@/misc/global.vue';

export const regulations = {
  namespaced: true,

  state: {
    // 读取某一行业的法规清单
    industry: null,
    // 获取某一机构发布的法律法规或监管要求清单
    committee: null,
    // 在法规文号、法规发布年限、法规名称、发布机构中进行搜索，获得包含关键字的法规清单
    searchTitle: null,
    // 获取法规全文
    regulationsContents: null,
    // 在法规条款内容中进行搜索，获得包含关键字的标准条款
    searchContents: null,
  },

  mutations: {
    // 读取某一行业的法规清单
    getIndustry: (state, params) => {
      Vue.set(state, 'industry', null)
      axios.get(global_.BAK_URL + "getRegulationsIndustry/", {
        params: {
          keywords: params
        },
        async: false
      }).then(response => {
        Vue.set(state, 'industry', response.data)
      }).catch(() => {
        Vue.set(state, 'industry', [])
      })
    },

    // 获取某一机构发布的法律法规或监管要求清单
    getCommittee: (state, params) => {
      Vue.set(state, 'committee', null)
      axios.get(global_.BAK_URL + "getRegulationsCommittee/", {
        params: {
          keywords: params
        },
        async: false
      }).then(response => {
        Vue.set(state, 'committee', response.data)
      }).catch(() => {
        Vue.set(state, 'committee', [])
      })
    },

    // 在法规文号、法规发布年限、法规名称、发布机构中进行搜索，获得包含关键字的法规清单
    searchTitle: (state, params) => {
      state.searchRegulationsTitle = []
      axios.get(global_.BAK_URL + "searchRegulationsTitle/", {
        params: {
          keywords: params
        },
        async: false
      }).then(response => {
        Vue.set(state, "searchTitle", response.data);
      }).catch(() => {
        Vue.set(state, 'searchTitle', [])
      })
    },

    // 读取法规全文
    getContents: (state, params) => {
      Vue.set(state, 'regulationsContents', null)
      axios.get(global_.BAK_URL + "getRegulationsContents/", {
        params: {
          keywords: params
        },
        async: false,
      }).then(response => {
        Vue.set(state, 'regulationsContents', response.data)
      }).catch(() => {
        Vue.set(state, 'regulationsContents', [])
      })
    },

    // 在法规条款内容中进行搜索，获得包含关键字的标准条款
    searchContents: async (state, params) => {
      // 清空以前的搜索数据，防止误显示前次搜索结果
      Vue.set(state, 'searchContents', null)
      await axios.get(global_.BAK_URL + "searchRegulationsContents/", {
        params: {
          keywords: params
        },
        async: false
      }).then(response => {
        Vue.set(state, 'searchContents', response.data)
      }).catch(() => {
        Vue.set(state, 'searchContents', [])
      })
    },
  },

  actions: {
    // 读取某一行业的法规清单
    getIndustry: (context, params) => {
      context.commit("getIndustry", params)
    },
    // 在法规文号、法规发布年限、法规名称、发布机构中进行搜索，获得由统一机构发布的监管法规清单
    getCommittee: (context, params) => {
      context.commit("getCommittee", params)
    },
    // 在法规文号、法规发布年限、法规名称、发布机构中进行搜索，获得包含关键字的法规清单
    searchTitle: (context, params) => {
      context.commit("searchTitle", params)
    },
    // 在法规条款内容中进行搜索，获得包含关键字的法规条款
    searchContents: (context, params) => {
      context.commit("searchContents", params)
    },
    // 读取法规全文
    getContents: (context, params) => {
      context.commit("getContents", params)
    }
  }
}